// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Ufm7","notes":"Notes_notes__3V907"};